import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import {RequestAllReportDto, ResponsePreviewDto} from "../dto/attendance-summary.dto";
import {ResponseData} from "../../nest-responses";

@Injectable()
export class AttendanceSummaryApi {
  private readonly service: string = '';
  private readonly model: string = 'attendanceSummaryReport';

  constructor(
    private readonly nestApiProvider: NestApiProvider,
  ) {
  }

  public preview(payload: RequestAllReportDto): Observable<ResponsePreviewDto> {
    const method: string = 'POST';
    const func: string = 'preview';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePreviewDto>(method, url, params, urlParams, body);
  }

  public downloadExcel(payload: RequestAllReportDto): Observable<Blob> {
    const method: string = 'POST';
    const func: string = 'downloadExcel';
    const params: any = payload || {};
    const urlParams: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlob<Blob>(method, url, params);
  }

  public reportSendEmailPdf(payload: RequestAllReportDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'reportSendEmailPdf';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public reportSendEmailExcel(payload: RequestAllReportDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'reportSendEmailExcel';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public downloadPdf(payload: RequestAllReportDto): Observable<Blob> {
    const method: string = 'POST';
    const func: string = 'downloadPdf';
    const params: any = payload || {};
    const urlParams: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlob<Blob>(method, url, params);
  }

  public status(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'status';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body, null);
}
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/attendance-summary.api.ts